module.exports = __webpack_public_path__ + "static/img/DrivingForce_logo_2017_200px.4c6cb85.png";